import Decimal from "decimal.js";
import { DatabaseObject, Metrics } from "./class";
import { DateObject } from "./datetime";

export class Workorder extends DatabaseObject {
  static $route = "workorder";

  functional_location_id: string | null = null;

  hour: Decimal = new Decimal(0);
  cost: Decimal = new Decimal(0);
  order: string;

  order_type: string;
  notification: string;
  basic_start_date: DateObject;
  statutory_flag: boolean;
  functional_location: string;
  description: string;
  system_status: string;
  user_status: string;
  main_work_center: string;
  planner_group: string;
  created_on: DateObject;
  maintenance_plan: string;
  maintenance_item: string;

  static async importList(fileId: string) {
    await Workorder.$axios.$post(
      "/workorder/import-list",
      {},
      { params: { fileId } }
    );
  }

  get statutory_flag_display() {
    return this.statutory_flag ? "Yes" : "No";
  }
}
